export default __webpack_public_path__ + "static/media/bitbucket.a2f79f87.svg";